import { getKeys } from '@transcend-io/type-utils';

/**
 * Invert an object of string -> string[]
 *
 * @param obj - The object to invert
 * @returns The inverted object
 */
export function invertObjectList<
  TInKey extends string,
  TOutKey extends string,
>(obj: { [key in TInKey]: TOutKey[] }): { [key in TOutKey]?: TInKey[] } {
  const result: { [key in TOutKey]?: TInKey[] } = {};
  getKeys(obj).forEach((key) =>
    obj[key].forEach((value) => {
      const out = result[value];
      if (out) {
        out.push(key);
      } else {
        result[value] = [key];
      }
    }),
  );
  return result;
}
